import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { IEventOrderInfoModel, ILuckyWheelSummaryModel } from '../../models/eventModel';
import EventServices from '../../services/event';
import Modal from 'antd/lib/modal';
import { InfoCircleOutlined } from '@ant-design/icons';
import "./style.css"

const WheelComponent = (props: IProps, ref: React.Ref<IWheelRef>) => {
  let {
    segments,
    // winningSegment,
    onSpinning,
    onError,
    orderInfo,
    onFinished,
    isOnlyOnce = true,
    fontFamily = 'proxima-nova'
  } = props
  const segColors = [
    '#BF1E2E',
    '#BCBDC1',
    '#E6E7E9',
    '#BCBDC1',
    '#E6E7E9',
    '#FFFFFF',
    '#E6E7E9',
  ]
  const upDuration = 500
  const downDuration = 1500
  const size = 800
  const refCanvas = React.useRef<HTMLCanvasElement>(null)
  // const [winningSegment, setWinningSegment] = React.useState<string>()
  let luckyWheelSummary: ILuckyWheelSummaryModel | null;
  let winningSegment = "";
  let currentSegment = '';
  let isStarted = false;
  const [isFinished, setFinished] = useState(false);
  let timerHandle: any = 0;
  const timerDelay = segments.length;
  let angleCurrent = Math.PI + 1.122;
  let angleDelta = 0;
  let canvasContext: CanvasRenderingContext2D | null | undefined = null;
  let maxSpeed = Math.PI / segments.length;
  const upTime = segments.length * upDuration;
  const downTime = segments.length * downDuration;
  let spinStart = 0;
  let frames = 0;
  const width = 1800;
  const height = 1800;

  let centerX = width / 2;
  let centerY = height / 2;

  useEffect(() => {
    wheelInit();
    setTimeout(() => {
      window.scrollTo(0, 1);
    }, 0);
  }, []);

  const wheelInit = () => {
    initCanvas();
    wheelDraw();
  };

  const initCanvas = () => {
    /* eslint-disable */
    let canvas: HTMLCanvasElement | null = refCanvas?.current
    // eslint-enable
    if (navigator.userAgent.indexOf('MSIE') !== -1) {
      canvas = document.createElement('canvas');
      canvas.setAttribute('width', width.toString());
      canvas.setAttribute('height', height.toString());
      canvas.setAttribute('id', 'canvas');
      document.getElementById('wheel')?.appendChild(canvas);
    }
    // canvas?.addEventListener('click', spin);
    canvasContext = canvas?.getContext('2d');
    if (canvasContext) {
      canvasContext.imageSmoothingQuality = "high";
      canvasContext.imageSmoothingEnabled = true;
      canvasContext.lineCap = 'round'
      canvasContext.lineJoin = 'round'
    }
  };

  useImperativeHandle(ref, () => {
    return {
      clearUp: handleClearUp
    };
  });



  const handleClearUp = () => {
    setFinished(false)
    luckyWheelSummary = (null)
    winningSegment = ""
  }
  // console.log("winningSegment", winningSegment);


  const spin = async () => {
    if (isFinished && isOnlyOnce) {
      return
    }
    // debugger

    Modal.confirm({
      title: "Xác nhận",
      content: (<div>
        Xác nhận quay?
      </div>),
      icon: <InfoCircleOutlined />,
      okText: "Xác nhận & Quay",
      cancelText: "Dừng",
      onCancel() { },
      centered: true,
      async onOk() {
        if (isFinished && isOnlyOnce) {
          return;
        }
        if (!orderInfo) {
          return;
        }
        onSpinning?.(true)

        const response = await EventServices.spinLuckyWheel(`${orderInfo.eventId}`, {
          kde_order_id: orderInfo?.kdeOrderId,
          customer_name: orderInfo?.customerName,
          customer_phone: orderInfo?.customerPhone,
          store_code: `${orderInfo?.storeCode}`
        })
        if (!response) {
          onError?.()
          return
        }

        luckyWheelSummary = response;
        winningSegment = response.prize_id;
        // if (!isReady) {
        //   return
        // }
        // if (isFinished) {
        //   return;
        // }
        isStarted = true;
        if (timerHandle === 0) {
          spinStart = new Date().getTime();
          maxSpeed = Math.PI / segments.length;
          frames = 0;
          timerHandle = setInterval(onTimerTick, timerDelay);
        }
      }
    })

  };

  const onTimerTick = () => {
    frames++;
    draw();
    const duration = new Date().getTime() - spinStart;
    let progress = 0;
    let finished = false;
    if (duration < upTime) {
      progress = duration / upTime;
      angleDelta = maxSpeed * Math.sin((progress * Math.PI) / 2);
    } else {
      if (winningSegment) {
        if (currentSegment === winningSegment && frames > segments.length) {
          progress = duration / upTime;
          angleDelta = maxSpeed * Math.sin((progress * Math.PI) / 2 + Math.PI / 2);
          progress = 1;
        } else {
          progress = duration / downTime;
          angleDelta = maxSpeed * Math.sin((progress * Math.PI) / 2 + Math.PI / 2);
        }
      } else {
        progress = duration / downTime;
        angleDelta = maxSpeed * Math.sin((progress * Math.PI) / 2 + Math.PI / 2);
      }
      if (progress >= 1) finished = true;
    }

    angleCurrent += angleDelta;
    while (angleCurrent >= Math.PI * 2) angleCurrent -= Math.PI * 2;
    if (finished) {
      setFinished(true);
      onFinished(currentSegment, luckyWheelSummary);
      clearInterval(timerHandle);
      timerHandle = 0;
      angleDelta = 0;

      onSpinning?.(false)
    }
  };

  const wheelDraw = () => {
    clear();
    drawWheel();
    drawNeedle();
  };

  const draw = () => {
    clear();
    drawWheel();
    drawNeedle();
  };

  const drawSegment = (key: number, lastAngle: number, angle: number) => {
    const ctx = canvasContext;
    if (!ctx) {
      return
    }

      const seg = segments[key]
      const value = seg.title;
      const isDisabled = seg.disable;
      const opacity = isDisabled ? 0.4 : 1;
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(centerX, centerY);
      ctx.arc(centerX, centerY, size, lastAngle, angle, false);
      ctx.lineTo(centerX, centerY);
      ctx.closePath();
      // Draw image
      // ctx.fillStyle = segColors[key];
      ctx.fillStyle = segColors[key];
      ctx.globalAlpha = opacity; // Set opacity
      ctx.fill();
      ctx.globalAlpha = 1; // Reset global alpha
      ctx.stroke();
      ctx.save();
    // ctx.translate(centerX, centerY);
    const img = new Image(420, 420);
    img.src = seg.image_url; // Replace "path_to_your_image" with the path to your image
    const imgWidth = img.width; // Adjust the width of the image
    const imgHeight = img.height; // Adjust the height of the image
    const segmentMiddleAngle = (lastAngle + angle) / 2;

    const imgX = centerX + (size * 0.57) * Math.cos((lastAngle + angle) / 2); // Calculate X position
    const imgY = centerY + (size * 0.57) * Math.sin((lastAngle + angle) / 2); // Calculate Y position
    const verticalAngle = segmentMiddleAngle + Math.PI / 2; // Góc để hình ảnh đứng thẳng

    img.onload = () => {

      ctx.save();
      ctx.translate(imgX, imgY);
      ctx.rotate(verticalAngle);
      ctx.drawImage(img, -imgWidth / 2, -imgHeight / 2, imgWidth, imgHeight); // Vẽ hình ảnh
      ctx.restore();
      ctx.save();

      ctx.beginPath();

      const textX = centerX + (size * 0.87) * Math.cos((lastAngle + angle) / 2); // Calculate X position
      const textY = centerY + (size * 0.87) * Math.sin((lastAngle + angle) / 2); // Calculate Y position
      // ctx.moveTo(imgX, imgY);
      ctx.translate(textX, textY);
      ctx.rotate(verticalAngle);

      // Draw text
      ctx.fillStyle = seg?.order == 1 ? "#FDDD64" : 'black'; // Change color as needed
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.font = 'normal 42px Arial'; // Change font and size as needed
      // ctx.fillText(value, 0, 0); // Draw text

      const lines = value.split('\n');

      for (let i = 0; i < lines.length; i++) {
        ctx.fillText(lines[i], 0, 0 + (i * 50));
      }

      ctx.restore();

    };
    ctx.restore();

  };

  const drawWheel = () => {
    const ctx = canvasContext;
    if (!ctx) {
      return
    }
    let lastAngle = angleCurrent;
    const len = segments.length;
    const PI2 = Math.PI * 2;
    ctx.lineWidth = 4;
    ctx.strokeStyle = "#000";
    // debugger;
    // ctx.textBaseline = 'middle';
    // ctx.textAlign = 'center';
    // ctx.font = '1em ' + fontFamily;
    for (let i = 1; i <= len; i++) {
      const angle = PI2 * (i / len) + angleCurrent;
      drawSegment(i - 1, lastAngle, angle);
      lastAngle = angle;
    }

    // ctx.beginPath();

    // const img = new Image();
    // img.src = btnSpin;
    // const btnSize = 500
    // img.onload = () => {
    //   ctx.drawImage(img, centerX - btnSize / 2, centerY - btnSize / 2, btnSize, btnSize);
    // }


    // ctx.arc(centerX, centerY, 50, 0, PI2, false);
    // ctx.closePath();
    // ctx.fillStyle = "red";
    // ctx.lineWidth = 10;
    // ctx.strokeStyle = contrastColor;
    // ctx.fill();
    // ctx.font = 'bold 20px ' + fontFamily;
    // ctx.fillStyle = contrastColor;
    // ctx.textAlign = 'center';
    // ctx.fillText(buttonText, centerX, centerY + 3);
    // ctx.stroke();

    // ctx.beginPath();
    // ctx.arc(centerX, centerY, size, 0, PI2, false);
    // ctx.closePath();

    // ctx.lineWidth = 0;
    // ctx.strokeStyle = "#fff";
    // ctx.stroke();

  };

  const drawNeedle = () => {
    const ctx = canvasContext;
    if (ctx) {
      // ctx.lineWidth = 1;
      // ctx.strokeStyle = contrastColor;
      // ctx.fillStyle = contrastColor;
      // ctx.beginPath();
      // ctx.moveTo(centerX + 20, centerY - 50);
      // ctx.lineTo(centerX - 20, centerY - 50);
      // ctx.lineTo(centerX, centerY - 70);
      // ctx.closePath();
      // ctx.fill();
      const change = angleCurrent + Math.PI / 2;
      let i =
        segments.length -
        Math.floor((change / (Math.PI * 2)) * segments.length) -
        1;
      if (i < 0) i = i + segments.length;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      // ctx.fillStyle = primaryColor;
      ctx.fillStyle = "red"
      ctx.font = 'bold 1.5em ' + fontFamily;
      const seg = segments[i];
      currentSegment = seg.key;

      // const img = new Image();
      // img.src = btnSpin;
      // const btnSize = 500
      // // img.onload = () => resolve();
      // img.onload = () => {
      //   ctx.drawImage(img, centerX - btnSize / 2, centerY - btnSize / 2, btnSize, btnSize);
      //   ctx.save();
      //   ctx.restore();
      // }

      // const img2 = new Image();
      // img2.src = imgBorder;
      // const imgBorderSize = size * 2 + 280;
      // // const btnSize = 500
      // // img.onload = () => resolve();
      // img2.onload = () => {
      //   ctx.drawImage(img2, centerX - imgBorderSize / 2 - 10, centerY - imgBorderSize / 2 - 20, imgBorderSize, imgBorderSize);
      //   ctx.restore();
      // }


      // isStarted && ctx.fillText(seg.title, centerX + 10, centerY + size + 50);
    }
  };

  const clear = () => {
    const ctx = canvasContext;
    if (ctx) {
      ctx.clearRect(0, 0, width, height)
    }
  };

  return <div id='wheel' className='wheel'>
    <div className='wheel-wrapper'>
      <img src={imgBorder} width={950} height={950} className='img-border' />
      <canvas
        ref={refCanvas}
        id='canvas'
        width={width}
        height={height}
        style={{
          pointerEvents: isFinished && isOnlyOnce ? 'none' : 'auto',
          // backgroundColor: "red"
          width: (width / 2) + "px",
          height: "auto",
        }}
      />
      <img src={btnSpin} width={250} height={250} className='btn-spin' onClick={spin} style={{
        pointerEvents: isFinished && isOnlyOnce ? 'none' : 'auto'
      }} />
    </div>
  </div>
};

export default forwardRef(WheelComponent);

const btnSpin = "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/icon-spin.svg"
const imgBorder = "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/border-lucky-wheel.svg"

interface IProps {
  segments: ISegment[];
  segColors: string[];
  winningSegment?: string;
  onFinished: (segment: string, summary: ILuckyWheelSummaryModel | null) => void;
  primaryColor?: string;
  contrastColor?: string;
  buttonText?: string;
  isOnlyOnce?: boolean;
  size?: number;
  upDuration?: number;
  downDuration?: number;
  fontFamily?: string;
  orderInfo?: IEventOrderInfoModel | null,
  onError: () => void,
  onSpinning: (isSpinning: boolean) => void
}

interface ISegment {
  key: string,
  title: string,
  image_url: string,
  disable?: boolean,
  order: number
}


export interface IWheelRef {
  clearUp: () => void
}